import { useMemo } from 'react';

import { useFreeTrialsNavigationAnnouncement } from 'modules/campaigns/';
import { useEoDCampaignsNavigationAnnouncement } from 'modules/campaigns/hooks/useEoDCampaignsNavigationAnnouncement';
import { useWoltCapitalNavigationAnnouncement } from 'modules/wolt-capital';

import { useBusinessNavigationItems } from './useBusinessNavigationItems';
import { useVenueNavigationItems } from './useVenueNavigationItems';

export const navigationAnnouncementIdsList = ['campaigns-free-trials', 'end-of-day-campaigns', 'wolt-capital'] as const;

export const useGetNavigationAnnouncements = () => {
  const venueNavigationItems = useVenueNavigationItems();
  const businessNavigationItems = useBusinessNavigationItems();

  const visibleNavigationItemKeys = useMemo(
    () => [...venueNavigationItems, ...businessNavigationItems].map(navigationItem => navigationItem.key),
    [venueNavigationItems, businessNavigationItems],
  );

  const freeTrialsNavigationAnnouncement = useFreeTrialsNavigationAnnouncement();
  const eodCampaignsNavigationAnnouncement = useEoDCampaignsNavigationAnnouncement();
  const woltCapitalNavigationAnnouncement = useWoltCapitalNavigationAnnouncement();

  return [
    ...freeTrialsNavigationAnnouncement,
    ...eodCampaignsNavigationAnnouncement,
    ...woltCapitalNavigationAnnouncement,
  ].filter(navigationAnnouncement => visibleNavigationItemKeys.includes(navigationAnnouncement.navigationKey));
};
